import React from "react";
import GatewayField from "./GatewayField";

export default function GatewayCodeInput({ label = "Verification code", value, onChange, ...props }) {
  return (
    <GatewayField
      {...props}
      label={label}
      inputMode="numeric"
      autoComplete="one-time-code"
      maxLength={6}
      value={value}
      onChange={(event) => {
        const nextValue = event.target.value.replace(/\D/g, "").slice(0, 6);
        onChange?.({ ...event, target: { ...event.target, value: nextValue } });
      }}
      className="gatewayField--code"
    />
  );
}
